import SharedHeading from '@homeflow/v4-lib/components/heading';
import { JSX, ComponentPropsWithRef } from 'react';

/* WHEN CHANGING THE HEADING CLASSES ALSO CHANGE THE CLASSES IN THE PROSE CLASSES FILE */
const headingClasses = {
  1: 'text-center mb-2.5 text-3xl font-bold',
  2: 'text-center mb-2.5 text-2xl font-bold',
  3: 'text-center mb-2.5 text-xl font-bold',
  5: 'text-center mb-2.5 text-base font-bold',
  6: 'text-center mb-2.5 text-base font-bold',
};

export default function Heading({
  children,
  ...otherProps
}: ComponentPropsWithRef<'h1'> & {
  level?: number;
  styleLevel?: number;
}): JSX.Element {
  return (
    <SharedHeading headingClasses={headingClasses} {...otherProps}>
      {children}
    </SharedHeading>
  );
}
